<template>
  <svg width="112" height="100" viewBox="0 0 112 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_508_395)">
      <path d="M31.9998 100C14.7998 100 2.39984 88.8 0.79984 74C-0.0001598 65.2 2.39984 57.2 8.79984 51.2C22.7998 36.8 37.1998 22.4 51.5998 8.40001C53.1998 6.80001 55.5998 6.80001 57.1998 8.00001C58.7998 9.60001 58.7998 12 56.7998 13.6C42.3998 28 28.3998 42 13.9998 56.4C7.99984 62.4 6.39984 69.6 8.39984 77.6C10.7998 85.6 15.9998 90.4 23.9998 92.4C31.5998 94 37.9998 92.4 43.5998 86.8C61.9998 68.4 80.7998 50 99.1998 31.2C103.2 27.2 104.4 22 102.4 16.4C100.4 10.8 95.9998 8.00001 89.9998 7.60001C85.9998 7.20001 82.3998 8.80001 79.5998 12C65.9998 26 51.9998 39.6 38.3998 53.6C37.5998 54.4 36.7998 55.2 35.9998 56C33.5998 58.8 33.1998 62.4 35.9998 64.8C38.3998 67.2 42.3998 67.2 45.1998 64.8C51.5998 58.4 57.9998 52 64.3998 45.6C67.5998 42.4 70.3998 39.6 73.5998 36.4C74.7998 35.2 76.3998 34.8 77.9998 35.6C79.1998 36.4 80.3998 37.6 79.9998 39.2C79.9998 40 79.5998 41.2 78.7998 41.6C69.1998 51.2 59.9998 60.8 50.3998 70C44.7998 75.2 36.3998 75.2 31.1998 69.6C25.9998 64.4 25.9998 55.6 31.1998 50C45.1998 36 59.9998 20.8 75.1998 6.00001C81.1998 1.09673e-05 88.7998 -1.59999 96.7998 1.20001C104.8 4.00001 109.6 9.60001 111.2 18C112 25.2 110 31.2 105.2 36C101.2 40.4 96.7998 44.4 92.7998 48.4C78.7998 62.4 64.3998 76.8 50.3998 90.8C44.3998 96.8 37.5998 100 31.9998 100Z" fill="#D9D9D9"/>
    </g>
    <defs>
      <clipPath id="clip0_508_395">
        <rect width="112" height="100" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>

</script>

<style scoped lang="scss">

</style>
